import React from 'react'

import i18n from 'translations'

export const CoordinatorHome = [
  {
    name: i18n.t('dashboard:name'),
    component: React.lazy(() => import('../../modules/coordinator/CoordinatorHomeComponent')),
    path: '/coordinator',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('blox-creation:bloxCreation'),
    component: React.lazy(() => import('../../modules/coordinator/blox-creation/form/BloxCreationForm')),
    path: '/coordinator/blox-creation',
    guards: ['allowOnlyLogged', 'allowBloxCreation'],
  },
  {
    name: i18n.t('blox-creation:editBlox'),
    component: React.lazy(() => import('../../modules/coordinator/blox-creation/form/BloxCreationForm')),
    path: '/coordinator/blox-creation/:id',
    guards: ['allowOnlyProfessor', 'allowBloxEdit'],
  },
  {
    name: i18n.t('blox-creation:bloxList'),
    component: React.lazy(() => import('../../modules/common/BloxList')),
    path: '/coordinator/blox-list/',
    guards: ['allowOnlyLogged', 'allowOnlyCoordinator', 'allowBloxList'],
  },
  {
    name: i18n.t('blox-creation:classView'),
    component: React.lazy(() => import('../../modules/LMS/LectureView/index.js')),
    path: '/coordinator/blox/:bloxId/lecture/:lectureId/preview',
    guards: ['allowOnlyLogged'],
  },
]
